import { PayloadAction } from '@reduxjs/toolkit';
import { UserType } from './types';
import { initialState } from './index';

export const reducers = {
  getUser(state) {
    state.isLoading = true;
  },
  getUserSuccess(state, action: PayloadAction<UserType>) {
    state.data = action.payload;
    state.isLoading = false;
    state.error = initialState.error;
  },
  getUserError(state, action: PayloadAction<any>) {
    state.data = initialState.data;
    state.error = action.payload;
    state.isLoading = false;
  },
};
